import { IonIcon } from '@ionic/react'
import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import { flash } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../../analytics/utils/firebaseUtils'
import Button from '../../../../components/actions/Button'
import { useElectronicCar } from '../hooks/useEletronicCar'
import { SmartChargeOverrideHook } from '../hooks/useSmartChargeOverride'

interface Props {
	vehicleId: string
	vehicle: ENodeVehicle | null | undefined
	smartOverride: SmartChargeOverrideHook
}

export const ElectricCarActionButtons: React.FC<Props> = ({ vehicleId, smartOverride }) => {
	const electronicCarHook = useElectronicCar(vehicleId)
	if (!electronicCarHook) return null
	const { t } = useTranslation('pages_electricCar')

	const { vehicle, vehicleAtChargingLocation } = electronicCarHook

	if (!vehicle) return null

	if (vehicle.smartChargingPolicy.isEnabled)
		return (
			<div className='buttons'>
				{!smartOverride?.actionPending && (
					<>
						{!smartOverride?.isEnabled &&
							!vehicle.chargeState.isCharging &&
							!vehicle.chargeState.isFullyCharged &&
							vehicleAtChargingLocation &&
							vehicle.chargeState.isPluggedIn && (
								<Button
									disabled={smartOverride?.actionPending}
									className='dark:![--background:#3cb49f] ![--background:#52ae32]'
									onClick={() => {
										logEvent('click-ev-enable-smart-override')
										smartOverride?.enable()
									}}
								>
									<IonIcon icon={flash} /> {t('electricCarActionButtons.lataaNyt')}
								</Button>
							)}

						{smartOverride?.isEnabled && (
							<Button
								disabled={smartOverride?.actionPending}
								className='dark:![--background:#3cb49f] ![--background:#52ae32]'
								onClick={() => {
									logEvent('click-ev-enable-smart-disable')
									smartOverride?.disable()
								}}
							>
								<IonIcon icon={flash} /> {t('electricCarActionButtons.palaa')}
							</Button>
						)}
					</>
				)}
			</div>
		)

	return <div className='buttons'></div>
}
